<template>
  <div id="applyExtraPoints">
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="事项（岗位职责项）" :label-width="formLabelWidth" prop="textarea1">
        <el-select v-model="form.textarea1" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="事由" :label-width="formLabelWidth">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="form.textarea2"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="描述" :label-width="formLabelWidth">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="form.textarea3"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="canCelVisible" size="mini">取 消</el-button>
      <el-button type="primary" @click="checkForm" size="mini">提 交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyExtraPoints',
  props: [
    'formvisible'
  ],
  data () {
    return {
      rules: {
        textarea1: [
          { required: true, message: '请选择一个', trigger: ['blur', 'change'] }
        ]
      },
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        textarea1: '',
        textarea2: '',
        textarea3: ''
      },
      options: [{
        value: '1',
        label: '诚信正直'
      }, {
        value: '2',
        label: '执行力'
      }, {
        value: '3',
        label: '培养人才'
      }, {
        value: '4',
        label: '思考能力'
      }, {
        value: '5',
        label: '规划力'
      }, {
        value: '6',
        label: '领导力'
      }, {
        value: '7',
        label: '创新改进'
      }, {
        value: '8',
        label: '目标管理'
      }],
      formLabelWidth: '160px'
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    checkForm () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit () {
      this.$message({
        message: '提交成功！',
        type: 'success',
        duration: 1000,
        onClose: () => {
          this.$emit('update:formvisible', false)
        }
      })
    },
    canCelVisible () {
      this.$emit('update:formvisible', false)
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.dialog-footer
  text-align right
</style>
